/**************************************************************
 * Generated by: `php artisan permissions:generate-typescript`
 * Generated at: 2025-05-01 18:10:21 UTC
 * Git branch: RAISE-2156-Finance-CRM-Roles
 * Last commit: f5ee1bdd4fbbb93342818b58cc513d4271309ded
 **************************************************************/

export type PermissionEnum =
    | AccountApiKeyPermission
    | AccountChapterPermission
    | AccountMemberPermission
    | AccountPermission
    | AuctionPermission
    | CampaignMemberPermission
    | CampaignPermission
    | CommunicationPermission
    | ContactPermission
    | ContentPermission
    | DiscountCodePermission
    | EventPermission
    | FinancePermission
    | FundPermission
    | ImportPermission
    | ReportPermission
    | SegmentPermission
    | TaskPermission
    | TicketPermission
    | TransactionPermission
    | WebhookPermission
    | WorkflowPermission
    | AccountOwnerPermission
    | GivebutterPermission
    | TestPermission;

export enum AccountApiKeyPermission {
    VIEW = 'account_api_keys.view', // View
    CREATE = 'account_api_keys.create', // Create
    EDIT = 'account_api_keys.edit', // Edit
    DELETE = 'account_api_keys.delete', // Delete
}

export enum AccountChapterPermission {
    VIEW = 'chapters.view', // View
    CREATE = 'chapters.create', // Create
    EDIT = 'chapters.edit', // Edit
    DELETE = 'chapters.delete', // Delete
}

export enum AccountMemberPermission {
    VIEW = 'account_member.view', // View
    INVITE = 'account_member.invite', // Invite new account members
    EDIT = 'account_member.edit', // Edit account member's permissions
    DELETE = 'account_member.delete', // Delete
}

export enum AccountPermission {
    VIEW = 'account.view', // View Account
    EDIT = 'account.edit', // Edit Account
    PLUS_MANAGEMENT = 'account.plus_management', // Manage Givebutter Plus subscription
    CLOSE_ACCOUNT = 'account.close', // Close account
    SETTINGS = 'account.settings', // Change account settings
    INTEGRATIONS = 'account.integrations', // Manage account integrations
}

export enum AuctionPermission {
    VIEW = 'auctions.view', // View
    CREATE = 'auctions.create', // Create
    CHARGE_BID = 'auctions.charge_bid', // Charge bid
    DISQUALIFY_BID = 'auctions.disqualify_bid', // Disqualify bid
    APPROVE_BIDDER = 'auctions.approve_bidder', // Approve bidder
    BAN_BIDDER = 'auctions.ban_bidder', // Ban bidder
    REGISTER_BIDDER = 'auctions.register_bidder', // Register bidder
    INVOICE_BIDDER = 'auctions.invoice_bidder', // Invoice bidder
    PLACE_BID = 'auctions.place_bid', // Place bid
    OFFER_SECOND_CHANCE = 'auctions.offer_second_chance', // Offer second chance
    EDIT = 'auctions.edit', // Edit
    CANCEL = 'auctions.cancel', // Cancel or delete an auction
}

export enum CampaignMemberPermission {
    VIEW = 'campaign_member.view', // View
    INVITE = 'campaign_member.invite', // Invite new campaign members
    EDIT = 'campaign_member.edit', // Edit campaign member
    DELETE = 'campaign_member.delete', // Delete
}

export enum CampaignPermission {
    VIEW = 'campaigns.view', // View
    CREATE = 'campaigns.create', // Create
    EDIT = 'campaigns.edit', // Edit
    DELETE = 'campaigns.delete', // Delete
}

export enum CommunicationPermission {
    SEND = 'communications.send', // Send
    VIEW = 'communications.view', // View
    SETTINGS = 'communications.settings', // Manage settings
}

export enum ContactPermission {
    VIEW = 'contacts.view', // View
    CREATE = 'contacts.create', // Create
    EDIT = 'contacts.edit', // Edit
    EXPORT = 'contacts.export', // Export
    ARCHIVE = 'contacts.archive', // Archive
    DELETE = 'contacts.delete', // Delete
}

export enum ContentPermission {
    VIEW_CAMPAIGN = 'content.campaign.view', // View Campaign Content
    EDIT_CAMPAIGN = 'content.campaign.edit', // Edit Campaign Content
    VIEW_EMAIL_TEMPLATES = 'content.email_templates.view', // View Email Templates
    MANAGE_EMAIL_TEMPLATES = 'content.email_templates.manage', // Manage Email Templates
}

export enum DiscountCodePermission {
    VIEW = 'discounts_codes.view', // View
    CREATE = 'discounts_codes.create', // Create
    EDIT = 'discounts_codes.edit', // Edit
    DELETE = 'discounts_codes.delete', // Delete
}

export enum EventPermission {
    VIEW = 'events.view', // View
    CREATE = 'events.create', // Create
    EDIT = 'events.edit', // Edit
    DELETE = 'events.delete', // Delete
}

export enum FinancePermission {
    REPORTS = 'finance.reports', // View reports
    PAYOUTS = 'finance.payouts', // Manage payouts
    SETTINGS = 'finance.settings', // Manage settings
}

export enum FundPermission {
    CREATE = 'funds.create', // Create
    EDIT = 'funds.edit', // Edit
    DELETE = 'funds.delete', // Delete
}

export enum ImportPermission {
    VIEW = 'imports.view', // View
    CREATE = 'imports.create', // Create
    EDIT = 'imports.edit', // Edit
    DELETE = 'imports.delete', // Delete
}

export enum ReportPermission {
    BASIC = 'reports.basic', // View basic reports
    CREATE_CUSTOM = 'reports.custom.create', // Create custom reports
    VIEW_CUSTOM = 'reports.custom.view', // View custom reports
    EXPORT = 'reports.export', // Create export reports
}

export enum SegmentPermission {
    VIEW = 'segment.view', // View
    CREATE = 'segment.create', // Create
    EDIT = 'segment.edit', // Edit
    DELETE = 'segment.delete', // Delete
}

export enum TaskPermission {
    VIEW = 'task.view', // View
    CREATE = 'task.create', // Create
    EDIT = 'task.edit', // Edit
    DELETE = 'task.delete', // Delete
}

export enum TicketPermission {
    VIEW = 'ticket.view', // View
    CREATE = 'ticket.create', // Create
    EDIT = 'ticket.edit', // Edit
    CHECK_IN = 'ticket.check_in', // Check in
    DELETE = 'ticket.delete', // Delete
}

export enum TransactionPermission {
    VIEW = 'transactions.view', // View
    ACKNOWLEDGE = 'transactions.acknowledge', // Acknowledge
    EDIT = 'transactions.edit', // Edit
    DELETE = 'transactions.delete', // Delete a transaction. Transactions can only be deleted if they did not have a payment made through givebutter.
    FULFILL = 'transactions.fulfill', // Mark an item as fulfilled
    PROCESS = 'transactions.process', // Process
    REFUND = 'transactions.refund', // Refund
    IMPORT_PLANS = 'transactions.import_plans', // Import plans
    MANAGE_PLAN = 'transactions.manage_plan', // Pause, resume and cancel plans.
    MANAGE_PLEDGE = 'transactions.manage_pledge', // Create, edit and delete pledges.
}

export enum WebhookPermission {
    VIEW = 'webhooks.view', // View
    CREATE = 'webhooks.create', // Create
    EDIT = 'webhooks.edit', // Edit
    DELETE = 'webhooks.delete', // Delete
}

export enum WorkflowPermission {
    VIEW = 'workflow.view', // View
    CREATE = 'workflow.create', // Create
    EDIT = 'workflow.edit', // Edit
    DELETE = 'workflow.delete', // Delete
}

export enum AccountOwnerPermission {
    OWNER = 'owner.account', // Account Owner
}

export enum GivebutterPermission {
    ADMIN = 'givebutter.admin', // Customer Service Employee
    ENGINEERING = 'givebutter.engineering', // Engineering Employee
}

export enum TestPermission {
    FAIL = 'test.fail', // Always Fail Test
    QUOTED = 'test.quoted', // Test 'quoted' description
}
export const PermissionNames: { [index: string]: string } = {
    'account_api_keys.view': 'Account api key- View',
    'account_api_keys.create': 'Account api key- Create',
    'account_api_keys.edit': 'Account api key- Edit',
    'account_api_keys.delete': 'Account api key- Delete',
    'chapters.view': 'Account chapter- View',
    'chapters.create': 'Account chapter- Create',
    'chapters.edit': 'Account chapter- Edit',
    'chapters.delete': 'Account chapter- Delete',
    'account_member.view': 'Account member- View',
    'account_member.invite': 'Invite new account members',
    'account_member.edit': "Edit account member's permissions",
    'account_member.delete': 'Account member- Delete',
    'account.view': 'View Account',
    'account.edit': 'Edit Account',
    'account.plus_management': 'Manage Givebutter Plus subscription',
    'account.close': 'Close account',
    'account.settings': 'Change account settings',
    'account.integrations': 'Manage account integrations',
    'auctions.view': 'Auction- View',
    'auctions.create': 'Auction- Create',
    'auctions.charge_bid': 'Auction- Charge bid',
    'auctions.disqualify_bid': 'Auction- Disqualify bid',
    'auctions.approve_bidder': 'Auction- Approve bidder',
    'auctions.ban_bidder': 'Auction- Ban bidder',
    'auctions.register_bidder': 'Auction- Register bidder',
    'auctions.invoice_bidder': 'Auction- Invoice bidder',
    'auctions.place_bid': 'Auction- Place bid',
    'auctions.offer_second_chance': 'Auction- Offer second chance',
    'auctions.edit': 'Auction- Edit',
    'auctions.cancel': 'Auction- Cancel or delete an auction',
    'campaign_member.view': 'Campaign member- View',
    'campaign_member.invite': 'Invite new campaign members',
    'campaign_member.edit': 'Edit campaign member',
    'campaign_member.delete': 'Campaign member- Delete',
    'campaigns.view': 'Campaign- View',
    'campaigns.create': 'Campaign- Create',
    'campaigns.edit': 'Campaign- Edit',
    'campaigns.delete': 'Campaign- Delete',
    'communications.send': 'Communication- Send',
    'communications.view': 'Communication- View',
    'communications.settings': 'Communication- Manage settings',
    'contacts.view': 'Contact- View',
    'contacts.create': 'Contact- Create',
    'contacts.edit': 'Contact- Edit',
    'contacts.export': 'Contact- Export',
    'contacts.archive': 'Contact- Archive',
    'contacts.delete': 'Contact- Delete',
    'content.campaign.view': 'Content- View Campaign Content',
    'content.campaign.edit': 'Content- Edit Campaign Content',
    'content.email_templates.view': 'Content- View Email Templates',
    'content.email_templates.manage': 'Content- Manage Email Templates',
    'discounts_codes.view': 'Discount code- View',
    'discounts_codes.create': 'Discount code- Create',
    'discounts_codes.edit': 'Discount code- Edit',
    'discounts_codes.delete': 'Discount code- Delete',
    'events.view': 'Event- View',
    'events.create': 'Event- Create',
    'events.edit': 'Event- Edit',
    'events.delete': 'Event- Delete',
    'finance.reports': 'Finance- View reports',
    'finance.payouts': 'Finance- Manage payouts',
    'finance.settings': 'Finance- Manage settings',
    'funds.create': 'Fund- Create',
    'funds.edit': 'Fund- Edit',
    'funds.delete': 'Fund- Delete',
    'imports.view': 'Import- View',
    'imports.create': 'Import- Create',
    'imports.edit': 'Import- Edit',
    'imports.delete': 'Import- Delete',
    'reports.basic': 'Report- View basic reports',
    'reports.custom.create': 'Report- Create custom reports',
    'reports.custom.view': 'Report- View custom reports',
    'reports.export': 'Report- Create export reports',
    'segment.view': 'Segment- View',
    'segment.create': 'Segment- Create',
    'segment.edit': 'Segment- Edit',
    'segment.delete': 'Segment- Delete',
    'task.view': 'Task- View',
    'task.create': 'Task- Create',
    'task.edit': 'Task- Edit',
    'task.delete': 'Task- Delete',
    'ticket.view': 'Ticket- View',
    'ticket.create': 'Ticket- Create',
    'ticket.edit': 'Ticket- Edit',
    'ticket.check_in': 'Ticket- Check in',
    'ticket.delete': 'Ticket- Delete',
    'transactions.view': 'Transaction- View',
    'transactions.acknowledge': 'Transaction- Acknowledge',
    'transactions.edit': 'Transaction- Edit',
    'transactions.delete':
        'Delete a transaction. Transactions can only be deleted if they did not have a payment made through givebutter.',
    'transactions.fulfill': 'Mark an item as fulfilled',
    'transactions.process': 'Transaction- Process',
    'transactions.refund': 'Transaction- Refund',
    'transactions.import_plans': 'Transaction- Import plans',
    'transactions.manage_plan': 'Pause, resume and cancel plans.',
    'transactions.manage_pledge': 'Create, edit and delete pledges.',
    'webhooks.view': 'Webhook- View',
    'webhooks.create': 'Webhook- Create',
    'webhooks.edit': 'Webhook- Edit',
    'webhooks.delete': 'Webhook- Delete',
    'workflow.view': 'Workflow- View',
    'workflow.create': 'Workflow- Create',
    'workflow.edit': 'Workflow- Edit',
    'workflow.delete': 'Workflow- Delete',
    'owner.account': 'Account Owner',
    'givebutter.admin': 'Givebutter Employee Permissions- Customer Service Employee',
    'givebutter.engineering': 'Givebutter Employee Permissions- Engineering Employee',
    'test.fail': 'Testing- Always Fail Test',
    'test.quoted': "Testing- Test 'quoted' description",
};
